import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsPhoneConfigurationRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsPhoneConfigurationRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { HelpCenterSettingsPhoneConfigurationEntryPoint } from './ui/phone-configuration/index.tsx';

export const helpCenterSettingsPhoneConfigurationRouteEntry: Route = createEntry(
	helpCenterSettingsPhoneConfigurationRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.phone-configuration',
		layout: globalLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			return HelpCenterSettingsPhoneConfigurationEntryPoint;
		},
		resources: [
			...getServiceDeskNavigationResources(),
			serviceDeskContextResource,
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
